<template>
  <header class="workspace-topbar">
    <div class="workspace-breadcrumb">工作台 / {{ role.name }} / 业务概览</div>
    <div class="workspace-top-actions">
      <button class="workspace-notice">◌</button>
      <div class="identity-switch-wrap">
        <button class="identity-switch-btn" @click="switchOpen = !switchOpen">
          <i class="mini-role-icon">{{ role.short }}</i>
          <span><b>{{ role.name }}</b><span>点击切换生态身份</span></span>
          <em>⌄</em>
        </button>
        <div v-show="switchOpen" class="identity-switch-menu">
          <button
            v-for="r in roleList"
            :key="r.key"
            :class="['identity-switch-option', { active: r.key === currentRole }]"
            @click="switchRole(r.key); switchOpen = false"
            :style="`--opt-color:${r.color};--opt-soft:${r.soft}`"
          >
            <i>{{ r.short }}</i>
            <span><b>{{ r.name }}</b><span>{{ r.desc }}</span></span>
            <mark>{{ r.key === currentRole ? '当前' : '已开通' }}</mark>
          </button>
          <button class="identity-switch-option" @click="$router.push('/register'); switchOpen = false">
            <i style="--opt-color:#789;--opt-soft:#eef2f7">＋</i>
            <span><b>申请新身份</b><span>继续开通其他生态权限</span></span>
          </button>
        </div>
      </div>
      <div class="portal-avatar">谢</div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'WorkspaceTopBar',
  data() { return { switchOpen: false }; },
  computed: {
    ...mapState('workspace', ['currentRole']),
    ...mapGetters('workspace', ['currentRoleData', 'roleList']),
    role() { return this.currentRoleData || { name: '', short: '' }; }
  },
  methods: {
    switchRole(role) {
      this.$store.dispatch('workspace/switchRole', role);
      this.$router.push(`/workspace/${role}`);
    }
  }
};
</script>

<style lang="less" scoped>
.workspace-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 28px;
  border-bottom: 1px solid var(--line);
  background: rgba(5, 11, 24, 0.9);
  backdrop-filter: blur(12px);
  position: sticky; top: 0; z-index: 50;
}
.workspace-breadcrumb {
  font-size: 13px; color: #6f7d98;
}
.workspace-top-actions {
  display: flex; align-items: center; gap: 14px;
}
.workspace-notice {
  border: 0; background: none; color: #7d8aa5; font-size: 20px; cursor: pointer;
  &:hover { color: #fff; }
}
.identity-switch-wrap { position: relative; }
.identity-switch-btn {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 14px; border: 1px solid var(--line);
  border-radius: 999px; background: rgba(255,255,255,.035);
  color: #fff; cursor: pointer;
  b { font-size: 13px; display: block; }
  span span { font-size: 10px; color: #6f7d98; }
  em { font-size: 12px; color: #6f7d98; }
}
.mini-role-icon {
  width: 28px; height: 28px; border-radius: 9px;
  background: rgba(67, 217, 255, 0.12); display: grid;
  place-items: center; font-style: normal; font-size: 14px;
  color: var(--cyan);
}
.identity-switch-menu {
  position: absolute; top: 48px; right: 0;
  width: 300px; padding: 9px;
  background: #091426; border: 1px solid var(--line);
  border-radius: 16px; box-shadow: var(--shadow);
  z-index: 55;
}
.identity-switch-option {
  display: flex; align-items: center; gap: 10px;
  width: 100%; padding: 11px 12px; border: 0;
  background: transparent; color: #fff; cursor: pointer;
  border-radius: 11px; text-align: left;
  &:hover { background: rgba(255,255,255,.06); }
  i {
    width: 32px; height: 32px; border-radius: 10px;
    background: var(--opt-soft, rgba(255,255,255,.08));
    display: grid; place-items: center;
    color: var(--opt-color, #fff); font-style: normal;
    font-weight: 900; flex-shrink: 0;
  }
  b { display: block; font-size: 13px; }
  span span { font-size: 10px; color: #6f7d98; display: block; }
  mark { padding: 3px 6px; border-radius: 999px; background: rgba(96,221,165,.1); color: #60dda5; font-size: 9px; margin-left: auto; }
}
.portal-avatar {
  width: 38px; height: 38px; border-radius: 12px;
  background: linear-gradient(135deg, #ffd56a, #ff9b02);
  display: grid; place-items: center; font-weight: 800;
  color: #07101d;
}
</style>
